import {useNavigation} from '@react-navigation/native';
import {useUserStore} from 'contexts/StoreContext';
import {useTheme} from 'contexts/ThemeContext';
import {observer} from 'mobx-react';
import {Flows, ScreenName} from 'navigations/Screens';
import {createNavigationHeaderWebScreens} from 'navigations/TabBar';
import React from 'react';
import {Image, Text, TouchableOpacity, View} from 'react-native';
import ChangePhotoWeb, {ChangePhotoModalHandle} from '../changePhotoWeb';
import NavigationHeaderWebTabs from '../navigationHeaderWebTabs/index.web';
import ProfileWeb from '../profileWeb';
import styleSheet from './styles';

export interface NavigationHeaderWebProps {
  activeName: Flows | ScreenName;
}

const NavigationHeaderWeb = observer((props: NavigationHeaderWebProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const changePhotoModalRef = React.useRef<ChangePhotoModalHandle>(null);

  const userStore = useUserStore();

  const navigationHeaderWebScreens = createNavigationHeaderWebScreens(
    userStore.isAdmin,
    theme,
  );

  const navigation = useNavigation();

  const onProfileChangePhotoPress = () => {
    changePhotoModalRef.current?.switchVisible();
  };

  const onDeletePhotoPress = () => {};

  const renderItem = (index: number, name: string, tabTitle: string) => {
    return (
      <TouchableOpacity
        key={index}
        style={styles.itemContainer}
        onPress={() => navigation.navigate(name as never)}>
        <Text style={styles.text}>{tabTitle}</Text>
        {props.activeName == name && <View style={styles.activeLine} />}
      </TouchableOpacity>
    );
  };

  const Icon = (
    <TouchableOpacity
      style={styles.iconContainer}
      onPress={() => navigation.navigate(Flows.homeFlow as never)}>
      <Image
        source={theme.images.appIcon}
        resizeMode={'contain'}
        style={styles.appIcon}
      />
    </TouchableOpacity>
  );

  return (
    <View style={styles.container}>
      <View style={styles.leftPartContainer}>
        {Icon}
        <NavigationHeaderWebTabs
          activeName={props.activeName}
          renderItem={renderItem}
          navigationStack={navigationHeaderWebScreens}
          backgroundColor={{backgroundColor: theme.colors.white}}
        />
      </View>
      <ProfileWeb onChangePhotoPress={onProfileChangePhotoPress} />
      <ChangePhotoWeb
        ref={changePhotoModalRef}
        onDeletePhotoPress={onDeletePhotoPress}
      />
    </View>
  );
});

export default NavigationHeaderWeb;
